import { useState, useEffect } from "react";
import axios from "axios";
import styles from "../PD/pd.module.css";
import { url } from "../../../../../../../../../App";
import Cookies from "js-cookie";
import { ToastContainer, toast } from "react-toastify";
import { useBorrowerContext } from "../../../../../../store/borrower-details";

export default function JoinScreen({ getMeetingAndToken, meetingUrl, loanID }) {
  const token = Cookies.get("Token");
  const email = Cookies.get("Email");
  const { borrowerData } = useBorrowerContext();
  const fetchedBorrowerDetails = borrowerData.borrower;
  const fetchedLoanDetails = borrowerData.loan;
  console.log(fetchedLoanDetails);
  const [meetingId, setMeetingId] = useState(null);
  const [videoPDVisible, setvideoPDVisible] = useState(false);
  const [visible, setvisible] = useState(false);
  const [userName, setUserName] = useState("");

  useEffect(() => {
    if (email === "rupesh.bishnoi@credin.in") {
      setvisible(true);
    } else {
      axios
        .post(url + "/user/getsingle", {
          token: token,
          email: email,
          useremail: email
        })
        .then((res) => {
          console.log(res);
          if (res.data[0].permission.video_pd_analysis === false) {
            toast.error("You do not have permission for VideoPD")
          }
          else {
            setUserName(res.data[0].staff_name);
            setvideoPDVisible(res.data[0].permission.video_pd_analysis);
            setvisible(false);
          }
        })
        .catch((err) => {
          console.log(err);
        })
    }
  }, [email, token]);

  const onClick = async () => {
    if (!loanID) {
      toast.error("Please Select Loan ID");
      return;
    }
    const id = await getMeetingAndToken(meetingId);
    const lastname = borrowerData.borrower.borrower_lastname.trim();
    const firstname = borrowerData.borrower.borrower_firstname.trim();
    const name = `${firstname}-${lastname}`;
    // console.log(userName,"userName")
    const formattedUserName = userName.replace(/\s+/g, '-');
    const meetingUrl = id ? `${window.location.href}/pd?meetingId=${id}&name=${name}&Username=${formattedUserName}&loanId=${loanID}` : null;
    try {
      axios
        .post(url + "/videosdk/sms/trigger", {
          token: token,
          email: email,
          borrower_Id: fetchedBorrowerDetails.borrower_uniqueno,
          meetingUrl: meetingUrl,
          loan_Id: loanID,
        })
        .then((res) => {
          if (res.data.auth === false) {
            toast.error(res.data.message);
          } else {
            console.log(res);
          }
        })
        .catch((err) => {
          console.error("Error in SMS", err);
        });
    } catch (err) {
      console.error("Error in SMS", err);
    }
  };

  return (
    <>
      <div className={styles.joinscreenParentContainer}>
        {(videoPDVisible || visible) && (
          <div className={styles.joinscreenContainer}>
            <input
              type="text"
              className={styles.joinscreenInput}
              placeholder="Enter Meeting Id"
              onChange={(e) => {
                setMeetingId(e.target.value);
              }}
            />
            <button className={styles.joinBtn} onClick={onClick}>
              Join Meeting
            </button>
            {" or "}
            <button className={styles.createBtn} onClick={onClick}>
              Create New Meeting
            </button>
          </div>
        )}
      </div>
      <ToastContainer />
    </>
  );
}
